import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import {
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControl,
  Button,
} from "@material-ui/core";
import moment from "moment";
import IOSSwitch from '@components/iOSSwitch';
import { ExpandMore } from "@material-ui/icons";
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';

import { useDebouncedEffect } from "@hooks/debounceEffect";
import { useStore } from "@store/store";
import {
  FETCH_JOBS,
  FETCH_JOBS_RELOAD_DATA,
  FETCH_JOBS_SUCCESS,
  FETCH_JOBS_FAILURE,
  REVIEW_JOBS,
  REVIEW_JOBS_SUCCESS,
  REVIEW_JOBS_FAILURE,
  RESET_REDIRECTION,
  FETCH_INTERSTATE_JOBS_RELOAD_DATA,
  FETCH_INTERSTATE_JOBS,
  FETCH_INTERSTATE_JOBS_SUCCESS,
  FETCH_INTERSTATE_JOBS_FAILURE,
  FETCH_CARGO_WISE_JOB,
  FETCH_CARGO_WISE_JOB_SUCCESS,
  FETCH_CARGO_WISE_JOB_FAILURE,
} from "@utils/actionTypes";
import Header from "@components/header";
import SearchIcon from "@assets/images/search.svg";
import { materialCommonStyles } from "@utils/materialCommonStyles";
import API from "@services/axios";
import {
  getPermissions,
  getFilter,
  setFilter,
  removeFilter,
  isRolePermission,
  setInterstateMode,
  getInterstateMode
} from "@utils/commonFunctions";
import { rowsPerPageVal, dataJobStatus, sourceId, jobStatus } from "@utils/constant";
import { JobListingStyle } from "./style";
import CreateJob from "./create-job";
import CreateCompletedJob from "./create-completed-jobs";
import Filter from "./filter";
import TableListing from "./table-listing";
import { getCustomFormToDate } from "../../utils/commonFunctions";
import CreateInterstateJob from "./create-interstate-job";
import CargoWiseJobTableListing from "./cargo-wise-job-table-list";
import { use } from "react";


function JobListing() {
  const classes = JobListingStyle();
  const dashboardFilter = getFilter("jobDashboardFilter", true);
  const filter = getFilter("jobFilter", true);
  const allocateFilter = parseInt(getFilter("jobAllocate"));
  const cargoVolumeFilter = getFilter("cargoVolume");
  const materilClasses = materialCommonStyles();
  const [state, dispatch] = useStore();
  const [openFilter, setOpenFilter] = useState(false);
  const [allocate, setAllocate] = useState(
    !!allocateFilter ? parseInt(allocateFilter) : ""
  );
  const [dataTable, setData] = useState([]);
  const [mainCheck, setMainCheck] = useState(false);
  const [selectedArray, setSelectedArray] = useState([]);
  const [, setClick] = useState(false);
  const [search, setSearch] = useState("");
  const [allowSearch, setAllowSearch] = useState(true);
  const [debounceSearch, setDebounceSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [period, setPeriod] = useState(
    filter ? filter?.period : ""
  );
  const [openStartJob, setOpenStartJob] = useState(false);
  const [showStartJob, setShowStartJob] = useState(false);
  const [startJobPeriod, setStartJobPeriod] = useState(
    filter ? filter?.startJobPeriod : dashboardFilter ? dashboardFilter.period : ""
  );
  const [pagination, setPagination] = useState({
    page: 0,
    rowsPerPage: rowsPerPageVal
  });
  const [sort, setSort] = useState({
    order: "",
    orderBy: ""
  });

  const [filterData, setFilterData] = useState({
    jobStatus: filter ? filter.jobStatus : [],
    truckRego: filter ? filter.truckRego : [],
    driver: filter ? filter.driver : [],
    customer: filter
      ? filter?.customer
      : dashboardFilter
      ? dashboardFilter.customer
      : [],
    jobType: filter
      ? filter?.jobType
      : dashboardFilter
      ? dashboardFilter.jobType
      : [],
    city: filter ? filter?.city : dashboardFilter ? dashboardFilter.city : [],
    cargoType: cargoVolumeFilter
      ? Array.isArray(cargoVolumeFilter) ? cargoVolumeFilter : [parseInt(cargoVolumeFilter)]
      : filter
      ? filter.cargoType
      : dashboardFilter
      ? dashboardFilter.cargoType
      : [],
    cto: filter ? filter?.cto : dashboardFilter ? dashboardFilter.cto : [],
    startDate: filter
      ? filter?.startDate
      : "",
    endDate: filter
      ? filter?.endDate
      : "",
    startJobStartDate: filter
      ? filter?.startJobStartDate
      : dashboardFilter
      ? dashboardFilter.startDate
      : "",
    startJobEndDate: filter
      ? filter?.startJobEndDate
      : dashboardFilter
      ? dashboardFilter.endDate
      : "",
    trailerRego: [],
    pickUpCity: [],
    dropOffCity: [],
    coldTrackingVehicle: false,
    damageReportOnAwb: false
  });
  const [customDate, setCustomDate] = useState({
    startDate: null,
    endDate: null,
  });
  const [startJobCustomDate, setStartJobCustomDate] = useState({
    startJobStartDate: null,
    startJobEndDate: null,
  });

  const [isInterstateSwitch, setIsInterstateSwitch] = useState(!!JSON.parse(getInterstateMode("interstate")));
  const [isCargoWiseSwitch, setIsCargoWiseSwitch] = useState(false);

  const isPermission =
    getPermissions() && isRolePermission(getPermissions(), "jobReview") && !isInterstateSwitch;

  // API calling to get list of jobs
  const paramsGetJob = useMemo(() => {
    return {
      page: pagination.page + 1,
      size: pagination.rowsPerPage,
      ...(!!debounceSearch ? { search: debounceSearch } : {}),
      ...(!!sort.order ? { order: sort.order } : {}),
      ...(!!sort.orderBy ? { orderBy: sort.orderBy } : {}),

      filter: {
        ...(allocate === 1 ? { durationOver3Hours: 1 } : {}),
        ...(allocate === 2 ? { waitingTimeOver2Hours: 1 } : {}),
        ...(allocate === 3 ? { withoutJobCharge: 1 } : {}),
        ...(allocate === 4 ? { reviewNotCompleted: 1 } : {}),
        ...(allocate === 5 ? { AWBNotTakenFully: 1 } : {}),
        ...(allocate === 6 ? { childAccountNotMapped: 1 } : {}),
        ...(!!filterData.jobStatus.length
          ? { jobStatusId: filterData.jobStatus }
          : {}),
        ...(!!filterData.jobType.length
          ? { jobTypeId: filterData.jobType }
          : {}),
        ...(!!filterData.city.length ? { cityId: filterData.city } : {}),
        ...(!!filterData.truckRego.length
          ? { truckId: filterData.truckRego }
          : {}),
        ...(state?.common?.truckId
          ? { truckId: [state.common.truckId.truckId] }
          : {}),
        ...(!!filterData.driver.length ? { driverId: filterData.driver } : {}),
        ...(!!filterData.customer.length
          ? { customerId: filterData.customer }
          : {}),
        ...(!!filterData.cargoType.length
          ? { cargoTypeId: filterData.cargoType }
          : {}),
        ...(!!filterData.cto.length ? { ctoId: filterData.cto } : {}),
        ...(!!filterData.startDate
          ? { startDate: filterData.startDate }
          : !!customDate.startDate
          ? { startDate: filterData.startDate }
          : {}),
        ...(state?.common?.truckId
          ? { startDate: state?.common?.truckId.startDate }
          : {}),
        ...(!!filterData.endDate
          ? { endDate: filterData.endDate }
          : !!customDate.endDate
          ? { endDate: filterData.endDate }
          : {}),
        ...(state?.common?.truckId
          ? { endDate: state?.common?.truckId.endDate }
          : {}),
        ...(!!filterData.startJobStartDate
          ? { startJobStartDate: filterData.startJobStartDate }
          : !!startJobCustomDate.startJobStartDate
          ? { startJobStartDate: filterData.startJobStartDate }
          : {}),
        ...(!!filterData.startJobEndDate
          ? { startJobEndDate: filterData.startJobEndDate }
          : !!startJobCustomDate.startJobEndDate
          ? { startJobEndDate: filterData.startJobEndDate }
          : {}),
        ...(filterData.coldTrackingVehicle
          ? { isColdTrackingVehicle: filterData.coldTrackingVehicle }
          : {}),
        ...(filterData.damageReportOnAwb
          ? { isDamageReportOnAwb: filterData.damageReportOnAwb }
          : {})
      }
    };
  }, [
    pagination,
    debounceSearch,
    sort,
    allocate,
    filterData,
    customDate,
    startJobCustomDate,
    state?.common?.truckId
  ]);

  const paramsGetCargoWiseJob = useMemo(() => {
    return {
      page: pagination.page + 1,
      size: pagination.rowsPerPage,
      ...(!!debounceSearch ? { search: debounceSearch } : {}),
      order: sort.order !== "" ? sort.order : "desc",
      orderBy: sort.orderBy !== "" ? sort.orderBy : "id",
      filter: {
        ...(!!filterData.jobStatus.length
          ? { jobStatusId: filterData.jobStatus }
          : {}),
        ...(!!filterData.jobType.length
          ? { jobTypeId: filterData.jobType }
          : {}),
        ...(!!filterData.city.length ? { cityId: filterData.city } : {}),
        ...(!!filterData.truckRego.length
          ? { truckId: filterData.truckRego }
          : {}),
        ...(state?.common?.truckId
          ? { truckId: [state.common.truckId.truckId] }
          : {}),
        ...(!!filterData.driver.length ? { driverId: filterData.driver } : {}),
        ...(!!filterData.customer.length
          ? { customerId: filterData.customer }
          : {}),
        ...(!!filterData.cargoType.length
          ? { cargoTypeId: filterData.cargoType }
          : {}),
        ...(!!filterData.cto.length ? { ctoId: filterData.cto } : {}),
        ...(!!filterData.startDate
          ? { startDate: filterData.startDate }
          : !!customDate.startDate
            ? { startDate: filterData.startDate }
            : {}),
        ...(state?.common?.truckId
          ? { startDate: state?.common?.truckId.startDate }
          : {}),
        ...(!!filterData.endDate
          ? { endDate: filterData.endDate }
          : !!customDate.endDate
            ? { endDate: filterData.endDate }
            : {}),
        ...(state?.common?.truckId
          ? { endDate: state?.common?.truckId.endDate }
          : {}),
        ...(!!filterData.startJobStartDate
          ? { startJobStartDate: filterData.startJobStartDate }
          : !!startJobCustomDate.startJobStartDate
            ? { startJobStartDate: filterData.startJobStartDate }
            : {}),
        ...(!!filterData.startJobEndDate
          ? { startJobEndDate: filterData.startJobEndDate }
          : !!startJobCustomDate.startJobEndDate
            ? { startJobEndDate: filterData.startJobEndDate }
            : {}),
        ...(filterData.coldTrackingVehicle
          ? { isColdTrackingVehicle: filterData.coldTrackingVehicle }
          : {}),
        ...(filterData.damageReportOnAwb
          ? { isDamageReportOnAwb: filterData.damageReportOnAwb }
          : {})
      }
    };
  }, [
    pagination,
    debounceSearch,
    sort,
    filterData,
    customDate,
    startJobCustomDate,
    state?.common?.truckId
  ]);

  let getJobs = useCallback((payload = paramsGetJob, needReloadData = false) => {
      dispatch({ type: needReloadData ? FETCH_JOBS_RELOAD_DATA : FETCH_JOBS });
      let params = payload;
      if (!params?.search && (!params?.filter || Object.keys(params?.filter).length === 0))
      {
        API.get("jobs/optimized", { params })
        .then((response) => {
          dispatch({
            type: FETCH_JOBS_SUCCESS,
            payload: response.data.data,
          });

          updateJobData(
            response?.data?.data?.rows,
            row =>
              row.jobStatuses?.name === jobStatus.COMPLETED &&
              row.sourceId !== sourceId.CARGO_WISE
          );
        })
        .catch((error) => {
          dispatch({ type: FETCH_JOBS_FAILURE, payload: error });
        });
      } else {
        API.get("jobs", { params })
        .then((response) => {
          dispatch({
            type: FETCH_JOBS_SUCCESS,
            payload: response.data.data,
          });
          setData(response?.data?.data?.rows);
        })
        .catch((error) => {
          dispatch({ type: FETCH_JOBS_FAILURE, payload: error });
        });
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramsGetJob, selectedArray]);

  // API calling to get list of Interstate jobs
  const paramsGetInterstateJob = useMemo(() => {
    return {
      page: pagination.page + 1,
      size: pagination.rowsPerPage,
      ...(!!debounceSearch ? { search: debounceSearch } : {}),
      ...(!!sort.order ? { order: sort.order } : {}),
      ...(!!sort.orderBy ? { orderBy: sort.orderBy } : {}),

      filter: {
        ...(allocate === 1 ? { durationOver3Hours: 1 } : {}),
        ...(allocate === 2 ? { waitingTimeOver2Hours: 1 } : {}),
        ...(allocate === 3 ? { withoutJobCharge: 1 } : {}),
        ...(allocate === 4 ? { reviewNotCompleted: 1 } : {}),
        ...(allocate === 5 ? { AWBNotTakenFully: 1 } : {}),
        ...(allocate === 6 ? { childAccountNotMapped: 1 } : {}),
        ...(!!filterData.jobStatus.length
          ? { jobStatusId: filterData.jobStatus }
          : {}),
        ...(!!filterData.truckRego.length
          ? { truckId: filterData.truckRego }
          : {}),
        ...(!!filterData.trailerRego.length
          ? { trailerId: filterData.trailerRego }
          : {}),
        ...(!!filterData.driver.length ? { driverId: filterData.driver } : {}),
        ...(!!filterData.customer.length
          ? { customerId: filterData.customer }
          : {}),
        ...(!!filterData.pickUpCity.length
          ? { pickUpCityId: filterData.pickUpCity }
          : {}),
        ...(!!filterData.dropOffCity.length
          ? { dropOffCityId: filterData.dropOffCity }
          : {}),
        ...(!!filterData.startDate
          ? { startDate: filterData.startDate }
          : !!customDate.startDate
            ? { startDate: filterData.startDate }
            : {}),
        ...(state?.common?.truckId
          ? { startDate: state?.common?.truckId.startDate }
          : {}),
        ...(!!filterData.endDate
          ? { endDate: filterData.endDate }
          : !!customDate.endDate
            ? { endDate: filterData.endDate }
            : {}),
        ...(state?.common?.truckId
          ? { endDate: state?.common?.truckId.endDate }
          : {}),
        ...(!!filterData.startJobStartDate
          ? { startJobStartDate: filterData.startJobStartDate }
          : !!startJobCustomDate.startJobStartDate
            ? { startJobStartDate: filterData.startJobStartDate }
            : {}),
        ...(!!filterData.startJobEndDate
          ? { startJobEndDate: filterData.startJobEndDate }
          : !!startJobCustomDate.startJobEndDate
            ? { startJobEndDate: filterData.startJobEndDate }
            : {}),
        ...(filterData.coldTrackingVehicle
          ? { isColdTrackingVehicle: filterData.coldTrackingVehicle }
          : {}),
        ...(filterData.damageReportOnAwb
          ? { isDamageReportOnAwb: filterData.damageReportOnAwb }
          : {})
      }
    };
  }, [
    pagination,
    debounceSearch,
    sort,
    allocate,
    filterData,
    customDate,
    startJobCustomDate,
    state?.common?.truckId
  ]);

  let getInterstateJobs = useCallback((payload = paramsGetInterstateJob, needReloadData = false) => {
    dispatch({ type: needReloadData ? FETCH_INTERSTATE_JOBS_RELOAD_DATA : FETCH_INTERSTATE_JOBS });
    let params = payload;
    API.get("interstateJobs", { params })
      .then((response) => {
        dispatch({
          type: FETCH_INTERSTATE_JOBS_SUCCESS,
          payload: response.data.data,
        });
        
        updateJobData(
          response?.data?.data?.rows,
          row =>
            row.jobStatuses?.name === jobStatus.COMPLETED &&
            row.sourceId !== sourceId.CARGO_WISE
        );
      })
      .catch((error) => {
        dispatch({ type: FETCH_INTERSTATE_JOBS_FAILURE, payload: error });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedArray]);

  let getCargoWiseJob = useCallback((payload = paramsGetCargoWiseJob) => {
    dispatch({ type: FETCH_CARGO_WISE_JOB });
    API.get("/jobs/cargoWise", { params: payload })
      .then((response) => {
        dispatch({
          type: FETCH_CARGO_WISE_JOB_SUCCESS,
          payload: response.data.data,
        });

        updateJobData(
          response?.data?.data?.rows,
          row => row.jobStatuses?.name === jobStatus.COMPLETED
        );
      })
      .catch((error) => {
        dispatch({ type: FETCH_CARGO_WISE_JOB_FAILURE, payload: error });
      });
  }, [paramsGetCargoWiseJob, selectedArray]);

  const updateJobData = useCallback((rows = [], filterSelectable = () => true) => {
    const data = rows.map(item => ({
      ...item,
      _rowChecked: selectedArray.includes(item.id),
    }));

    setData(data);

    const selectableRows = data.filter(filterSelectable);

    setMainCheck(
      selectableRows.length > 0 &&
      selectableRows.every(row => row._rowChecked)
    );
  },[selectedArray]);

  useEffect(() => {
    try {
      if (state?.common?.truckId) {
        setPeriod(7);
        setShow(true);
        setFilterData({
          ...filterData,
          truckRego: [state?.common?.truckId.truckId],
          startDate: state?.common?.truckId.startDate,
          endDate: state?.common?.truckId.endDate,
        });
        setCustomDate({
          ...customDate,
          startDate: state?.common?.truckId.startDate,
          endDate: state?.common?.truckId.endDate,
        });
      }
    } catch (error) {
      console.log("Error", error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    pagination,
    sort,
    state?.common?.truckId,
    period,
    debounceSearch,
  ]);

  useEffect(() => {
    if (state?.redirection?.jobStatusRedirection) {
      setFilterData({
        ...filterData,
        jobStatus: [
          dataJobStatus.find(
            (item) => item.name === state?.redirection?.jobStatusRedirection
          ).id,
        ],
      });
      const payload = {
        ...paramsGetJob,
        filter: {
          ...paramsGetJob?.filter,
          jobStatusId: [
            dataJobStatus.find(
              (item) => item.name === state?.redirection?.jobStatusRedirection
            ).id
          ]
        }
      };
      getJobs(payload);
    }
    return () =>
      dispatch({
        type: RESET_REDIRECTION,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    state?.redirection?.filterRedirection,
  ]);

  useEffect(() => {
    if (state?.common?.truckId) {
      setFilter(
        "jobFilter",
        // {
        //   ...filterData,
        //   period:
        //     getCustomFormToDate(
        //       state?.common?.truckId?.startDate,
        //       state?.common?.truckId?.endDate
        //     ) || 7,
        //   startJobPeriod: "",
        // },
        {
          ...filterData,
          startDate: customDate.startDate,
          endDate: customDate.endDate,
        },
        true
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData,customDate, state?.common?.truckId]);

  useEffect(() => {
    setFilter("jobAllocate", allocateFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allocateFilter]);

  // Debounce the search after 1 second
  useDebouncedEffect(
    () => {
      if (allowSearch) {
        setDebounceSearch(search);
        resetPagination();

        if (isCargoWiseSwitch) {
          const getParamsGetCargoWiseJob = { ...paramsGetCargoWiseJob };
          delete getParamsGetCargoWiseJob?.search;
          const payload = {
            ...getParamsGetCargoWiseJob,
            page: 1,
            size: rowsPerPageVal,
            ...(!!search ? { search: search } : delete getParamsGetCargoWiseJob?.search)
          };
          getCargoWiseJob(payload);
        } else {
          if (isInterstateSwitch) { // For Interstate
            const getParamsGetInterstateJob = {
              ...paramsGetInterstateJob
            };
            delete getParamsGetInterstateJob?.search;
            const payload = {
              ...getParamsGetInterstateJob,
              page: 1,
              size: rowsPerPageVal,
              ...(!!search ? { search: search } : delete getParamsGetInterstateJob?.search)
            };
            getInterstateJobs(payload);
          } else { // For Local
            const getParamsGetJob = {
              ...paramsGetJob
            };
            delete getParamsGetJob?.search;
            const payload = {
              ...getParamsGetJob,
              page: 1,
              size: rowsPerPageVal,
              ...(!!search ? { search: search } : delete getParamsGetJob?.search)
            };
            getJobs(payload);
          }
        }
      }
    },
    1000,
    [search]
  );

  const openFilterPopup = () => {
    document.body.classList.toggle("open-filter");
    setOpenFilter(true);
  };

  const closeFilerPopup = () => {
    document.body.classList.remove("open-filter");
    setOpenFilter(false);
  };

  const handleSubmit = () => {
    resetPagination();

    if (isCargoWiseSwitch) {
      const payload = {
        ...paramsGetCargoWiseJob,
        page: 1,
        size: rowsPerPageVal,
      };
      getCargoWiseJob(payload);
    } else {
      if (isInterstateSwitch) { // For Interstate
        const payload = {
          ...paramsGetInterstateJob,
          page: 1,
          size: rowsPerPageVal,
        };
        getInterstateJobs(payload);
      } else { // For Local
        const payload = {
          ...paramsGetJob,
          page: 1,
          size: rowsPerPageVal,
        };
        getJobs(payload);
      }
    }

    setFilter("jobFilter", { ...filterData, period, startJobPeriod }, true);
    closeFilerPopup();
  };

  const handleReset = (needReloadData = false) => {
    removeFilter("jobFilter");
    removeFilter("jobDashboardFilter");
    removeFilter("jobAllocate");
    removeFilter("cargoVolume");
    document.body.classList.remove("open-filter");
    setOpenFilter(false);
    setShow(false);
    setPeriod("");
    setShowStartJob(false);
    setStartJobPeriod("");
    setFilterData({
      jobStatus: [],
      truckRego: [],
      driver: [],
      customer: [],
      jobType: [],
      city: [],
      cargoType: [],
      cto: [],
      startDate: null,
      endDate: null,
      startJobStartDate: null,
      startJobEndDate: null,
      trailerRego: [],
      pickUpCity: [],
      dropOffCity: [],
      coldTrackingVehicle: false,
      damageReportOnAwb: false
    });
    setCustomDate({
      startDate: null,
      endDate: null,
    });
    setStartJobCustomDate({
      startJobStartDate: null,
      startJobEndDate: null,
    });
    resetPagination();
    if (isCargoWiseSwitch) {
      const payload = {
        ...paramsGetCargoWiseJob,
        page: 1,
        size: rowsPerPageVal,
        filter: {}
      };
      getCargoWiseJob(payload);
    } else {
      if (isInterstateSwitch) { // For Interstate
        const payload = {
          ...paramsGetInterstateJob,
          page: 1,
          size: rowsPerPageVal,
          filter: {}
        };
        getInterstateJobs(payload, needReloadData);
      } else { // For Local
        const payload = {
          ...paramsGetJob,
          page: 1,
          size: rowsPerPageVal,
          filter: {
            ...(!!paramsGetJob?.filter?.durationOver3Hours ? { durationOver3Hours: paramsGetJob?.filter?.durationOver3Hours } : {}),
            ...(!!paramsGetJob?.filter?.waitingTimeOver2Hours ? { waitingTimeOver2Hours: paramsGetJob?.filter?.waitingTimeOver2Hours } : {}),
            ...(!!paramsGetJob?.filter?.AWBNotTakenFully ? { AWBNotTakenFully: paramsGetJob?.filter?.AWBNotTakenFully } : {}),
            ...(!!paramsGetJob?.filter?.withoutJobCharge ? { withoutJobCharge: paramsGetJob?.filter?.withoutJobCharge } : {}),
            ...(!!paramsGetJob?.filter?.reviewNotCompleted ? { reviewNotCompleted: paramsGetJob?.filter?.reviewNotCompleted } : {}),
            ...(!!paramsGetJob?.filter?.childAccountNotMapped ? { childAccountNotMapped: paramsGetJob?.filter?.childAccountNotMapped } : {})
          }
        };
        getJobs(payload, needReloadData);
      }
    }
  };

  const handleCustomDateSubmit = () => {
    setOpen(false);
    setShow(true);
    setFilterData({
      ...filterData,
      startDate: customDate.startDate,
      endDate: customDate.endDate,
    });
    setPeriod(7);
    resetPagination();

    if (isCargoWiseSwitch) {
      const payload = {
        ...paramsGetCargoWiseJob,
        page: 1,
        size: rowsPerPageVal,
        filter: {
          ...paramsGetCargoWiseJob.filter,
          startDate: customDate.startDate,
          endDate: customDate.endDate,
        }
      };
      getCargoWiseJob(payload);
    } else {
      if (isInterstateSwitch) { // For Interstate
        const payload = {
          ...paramsGetInterstateJob,
          page: 1,
          size: rowsPerPageVal,
          filter: {
            ...paramsGetInterstateJob.filter,
            startDate: customDate.startDate,
            endDate: customDate.endDate,
          }
        };
        getInterstateJobs(payload);
      } else { // For Local
        const payload = {
          ...paramsGetJob,
          page: 1,
          size: rowsPerPageVal,
          filter: {
            ...paramsGetJob.filter,
            startDate: customDate.startDate,
            endDate: customDate.endDate,
          }
        };
        getJobs(payload);
      }
    }
  };

  const handleStartJobCustomDateSubmit = () => {
    setOpenStartJob(false);
    setShowStartJob(true);
    setFilterData({
      ...filterData,
      startJobStartDate: startJobCustomDate.startJobStartDate,
      startJobEndDate: startJobCustomDate.startJobEndDate,
    });
    setStartJobPeriod(7);
    resetPagination();

    if (isCargoWiseSwitch) {
      const payload = {
        ...paramsGetCargoWiseJob,
        page: 1,
        size: rowsPerPageVal,
        filter: {
          ...paramsGetCargoWiseJob.filter,
          startJobStartDate: startJobCustomDate.startJobStartDate,
          startJobEndDate: startJobCustomDate.startJobEndDate,
        }
      };
      getCargoWiseJob(payload);
    } else {
      if (isInterstateSwitch) { // For Interstate
        const payload = {
          ...paramsGetInterstateJob,
          page: 1,
          size: rowsPerPageVal,
          filter: {
            ...paramsGetInterstateJob.filter,
            startJobStartDate: startJobCustomDate.startJobStartDate,
            startJobEndDate: startJobCustomDate.startJobEndDate,
          }
        };
        getInterstateJobs(payload);
      } else { // For Local
        const payload = {
          ...paramsGetJob,
          page: 1,
          size: rowsPerPageVal,
          filter: {
            ...paramsGetJob.filter,
            startJobStartDate: startJobCustomDate.startJobStartDate,
            startJobEndDate: startJobCustomDate.startJobEndDate,
          }
        };
        getJobs(payload);
      }
    }
  };

  const handleFilter = (event) => {
    const { name, value } = event.target;
    setFilterData({
      ...filterData,
      [name]: value,
    });

    resetPagination();

    let nameParam = {};
    if (name) {
      if (name === "truckRego") {
        nameParam = value?.length ? { truckId: value } : !isInterstateSwitch ? isCargoWiseSwitch ? delete paramsGetCargoWiseJob.filter[`truckId`] : delete paramsGetJob.filter[`truckId`] : delete paramsGetInterstateJob.filter[`truckId`];
      } else if (name === "trailerRego") {
        nameParam = value?.length ? { trailerId: value } : !isInterstateSwitch ? isCargoWiseSwitch ? delete paramsGetCargoWiseJob.filter[`trailerId`] : delete paramsGetJob.filter[`trailerId`] : delete paramsGetInterstateJob.filter[`trailerId`];
      } else {
        nameParam = value?.length ? { [`${name}Id`]: value } : !isInterstateSwitch ? isCargoWiseSwitch ? delete paramsGetCargoWiseJob.filter[`${name}Id`] : delete paramsGetJob.filter[`${name}Id`] : delete paramsGetInterstateJob.filter[`${name}Id`];
      }
    }

    if (isCargoWiseSwitch) {
      const payload = {
        ...paramsGetCargoWiseJob,
        page: 1,
        size: rowsPerPageVal,
        filter: {
          ...paramsGetCargoWiseJob.filter,
          ...nameParam
        }
      };
      getCargoWiseJob(payload);
    } else {
      if (isInterstateSwitch) { // For Interstate
        const payload = {
          ...paramsGetInterstateJob,
          page: 1,
          size: rowsPerPageVal,
          filter: {
            ...paramsGetInterstateJob.filter,
            ...nameParam
          }
        };
        getInterstateJobs(payload);
      } else { // For Local
        const payload = {
          ...paramsGetJob,
          page: 1,
          size: rowsPerPageVal,
          filter: {
            ...paramsGetJob.filter,
            ...nameParam
          }
        };
        getJobs(payload);
      }
    }
  };

  const handleSearch = (event) => {
    setSearch(event.target.value.trimStart());
    setAllowSearch(true);
  };

  const handleSorting = (event, property) => {
    const isAsc = sort.orderBy === property.sortTitle && sort.order === "asc";
    setSort(prev => (
      {
        ...prev,
        order: isAsc ? "desc" : "asc",
        orderBy: property.sortTitle
      }
    ));
    resetPagination();

    if (isCargoWiseSwitch) {
      const getParamsGetCargoWiseJob = { ...paramsGetCargoWiseJob };
      delete getParamsGetCargoWiseJob?.order;
      delete getParamsGetCargoWiseJob?.orderBy;
      const payload = {
        ...getParamsGetCargoWiseJob,
        page: 1,
        size: rowsPerPageVal,
        order: isAsc ? "desc" : "asc",
        orderBy: property.sortTitle
      };
      getCargoWiseJob(payload);
    } else {
      if (isInterstateSwitch) { // For Interstate
        const getParamsGetInterstateJob = { ...paramsGetInterstateJob };
        delete getParamsGetInterstateJob?.order;
        delete getParamsGetInterstateJob?.orderBy;
        const payload = {
          ...getParamsGetInterstateJob,
          page: 1,
          size: rowsPerPageVal,
          order: isAsc ? "desc" : "asc",
          orderBy: property.sortTitle
        };
        getInterstateJobs(payload);
      } else { // For Local
        const getParamsGetJob = { ...paramsGetJob };
        delete getParamsGetJob?.order;
        delete getParamsGetJob?.orderBy;
        const payload = {
          ...getParamsGetJob,
          page: 1,
          size: rowsPerPageVal,
          order: isAsc ? "desc" : "asc",
          orderBy: property.sortTitle
        };
        getJobs(payload);
      }
    }
  };

  const handleChangePage = (event, newPage) => {
    setPagination((prev) => (
      {
        ...prev,
        page: newPage
      }
    ));

    if (isCargoWiseSwitch) {
      const payload = {
        ...paramsGetCargoWiseJob,
        page: newPage + 1
      };
      getCargoWiseJob(payload);
    } else {
      if (isInterstateSwitch) { // For Interstate
        const payload = {
          ...paramsGetInterstateJob,
          page: newPage + 1
        };
        getInterstateJobs(payload);
      } else { // For Local
        const payload = {
          ...paramsGetJob,
          page: newPage + 1
        };
        getJobs(payload);
      }
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setPagination(prev => (
      {
        ...prev,
        rowsPerPage: parseInt(event.target.value, 10),
        page: 0
      }
    ));

    if (isCargoWiseSwitch) {
      const payload = {
        ...paramsGetCargoWiseJob,
        page: 1,
        size: parseInt(event.target.value, 10),
      };
      getCargoWiseJob(payload);
    } else {
      if (isInterstateSwitch) {
        const payload = {
          ...paramsGetInterstateJob,
          page: 1,
          size: parseInt(event.target.value, 10),
        };
        getInterstateJobs(payload);
      } else {
        const payload = {
          ...paramsGetJob,
          page: 1,
          size: parseInt(event.target.value, 10),
        };
        getJobs(payload);
      }
    }
  };

  const handleAllocate = (event) => {
    setAllocate(event.target.value);
    setFilter("jobAllocate", event.target.value);
    resetPagination();

    const getParamsGetJob = {
      ...paramsGetJob
    };
    delete getParamsGetJob?.filter?.durationOver3Hours;
    delete getParamsGetJob?.filter?.waitingTimeOver2Hours;
    delete getParamsGetJob?.filter?.withoutJobCharge;
    delete getParamsGetJob?.filter?.reviewNotCompleted;
    delete getParamsGetJob?.filter?.AWBNotTakenFully;
    delete getParamsGetJob?.filter?.childAccountNotMapped;
    const payload = {
      ...getParamsGetJob,
      page: 1,
      size: rowsPerPageVal,
      filter: {
        ...getParamsGetJob?.filter,
        ...(event.target.value === 1 ? { durationOver3Hours: 1 } : {}),
        ...(event.target.value === 2 ? { waitingTimeOver2Hours: 1 } : {}),
        ...(event.target.value === 3 ? { withoutJobCharge: 1 } : {}),
        ...(event.target.value === 4 ? { reviewNotCompleted: 1 } : {}),
        ...(event.target.value === 5 ? { AWBNotTakenFully: 1 } : {}),
        ...(event.target.value === 6 ? { childAccountNotMapped: 1 } : {}),
      }
    };
    getJobs(payload);
  };

  // To handle checkboxes from listing
  const handleChange = (item, e) => {
    let _id = item.id;
    let index = dataTable.findIndex((x) => x.id === _id);
    let data = dataTable;
    let newState = !item?._rowChecked;
    if (index > -1) {
      data[index]._rowChecked = newState;
      setData(data);
    }

    const filteredData = data.filter((row) => {
      if (isCargoWiseSwitch) {
        return row.jobStatuses?.name === jobStatus.COMPLETED;
      }

      return (
        row.jobStatuses?.name === jobStatus.COMPLETED &&
        row.sourceId !== sourceId.CARGO_WISE
      );
    });

    if (filteredData.filter((res, index) => res._rowChecked === true).length === filteredData.length) {
      setMainCheck(true);
    } else {
      setMainCheck(false);
    }
    
    const currentPageIds = (isCargoWiseSwitch && item?.primeConsolidatedJobs?.length)
      ? item.primeConsolidatedJobs.map(job => job.childJobId)
      : [item.id];

    setSelectedArray((prev) => {
      if (newState) { // Check
        return [...new Set([...prev, ...currentPageIds])];
      } else { // Uncheck
        return prev.filter((id) => !currentPageIds.includes(id));
      }
    });
  };

  // To handle main checkbox
  const handleMainChangeCheckBox = (e) => {
    const newState = e.target.checked;

    const listJob = dataTable.map((element) => {
      const isCompleted = element.jobStatuses?.name === jobStatus.COMPLETED;
      const isValidRow = isCargoWiseSwitch
        ? isCompleted
        : isCompleted && element.sourceId !== sourceId.CARGO_WISE;

      if (isValidRow) {
        return {
          ...element,
          _rowChecked: newState,
        };
      }
      
      return element;
    });
    
    setData(listJob);
    setMainCheck(newState);

    const currentPageIds = listJob.filter((row) => {
      const isCompleted = row.jobStatuses?.name === jobStatus.COMPLETED;
      return isCargoWiseSwitch
        ? isCompleted
        : isCompleted && row.sourceId !== sourceId.CARGO_WISE;
      }
    ).map((item) => {
      if (isCargoWiseSwitch && item?.primeConsolidatedJobs?.length ) {
        return item.primeConsolidatedJobs.map((job) => job.childJobId);
      }
      return item.id;
    });

    setSelectedArray((prev) => {
      if (newState) { // Check
        return [...new Set([...prev, ...currentPageIds])];
      } else { // Uncheck
        return prev.filter((id) => !currentPageIds.includes(id));
      }
    });
  };

  // API calling to review multiple jobs
  const handleClickShowData = () => {
    dispatch({ type: REVIEW_JOBS });
    API.put("jobs/reviewCompleted", { jobIds: selectedArray })
      .then((response) => {
        dispatch({
          type: REVIEW_JOBS_SUCCESS,
          payload: response.data.data,
        });
        setClick(true);
        setSelectedArray([]);
        if (isCargoWiseSwitch) {
          getCargoWiseJob();
          return;
        }
        getJobs();
      })
      .catch((error) => {
        dispatch({ type: REVIEW_JOBS_FAILURE, payload: error });
      });
  };

  const handleStartJobPeriodChange = (event, type) => {
    const { value } = event.target;
    setStartJobPeriod(value);
    setShowStartJob(false);
    if (!openFilter) {
      setFilter(
        "jobFilter",
        {
          ...filterData,
          startJobPeriod: value,
        },
        true
      );
    }
    if (value === 7 || type === true) {
      setOpenStartJob(true);
    } else {
      let startJobStartDate;
      let startJobEndDate;
      const newDate = new Date();
      if (value === "") {
        setFilterData({
          ...filterData,
          startJobStartDate: null,
          startJobEndDate: null,
        });
        setStartJobCustomDate({
          startJobStartDate: null,
          startJobEndDate: null,
        });
      } else if (value === 1) {
        startJobStartDate = moment(newDate).format("YYYY-MM-DD");
        startJobEndDate = moment(newDate).format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          startJobStartDate,
          startJobEndDate,
        });
      } else if (value === 2) {
        startJobStartDate = moment(newDate)
          .subtract(1, "day")
          .format("YYYY-MM-DD");
        startJobEndDate = moment(newDate)
          .subtract(1, "day")
          .format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          startJobStartDate,
          startJobEndDate,
        });
      } else if (value === 3) {
        startJobStartDate = moment(newDate)
          .subtract(3, "day")
          .format("YYYY-MM-DD");
        startJobEndDate = moment(newDate).format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          startJobStartDate,
          startJobEndDate,
        });
      } else if (value === 4) {
        startJobStartDate = moment(newDate)
          .subtract(7, "day")
          .format("YYYY-MM-DD");
        startJobEndDate = moment(newDate).format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          startJobStartDate,
          startJobEndDate,
        });
      } else if (value === 5) {
        startJobStartDate = moment(newDate)
          .subtract(14, "day")
          .format("YYYY-MM-DD");
        startJobEndDate = moment(newDate).format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          startJobStartDate,
          startJobEndDate,
        });
      } else if (value === 6) {
        startJobStartDate = moment(newDate)
          .subtract(30, "day")
          .format("YYYY-MM-DD");
        startJobEndDate = moment(newDate).format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          startJobStartDate,
          startJobEndDate,
        });
      }
      resetPagination();

      if (isCargoWiseSwitch) {
        const getParamsGetCargoWiseJob = {
          ...paramsGetCargoWiseJob
        };
        delete getParamsGetCargoWiseJob?.filter?.startJobStartDate;
        delete getParamsGetCargoWiseJob?.filter?.startJobEndDate;
        const payload = {
          ...getParamsGetCargoWiseJob,
          page: 1,
          size: rowsPerPageVal,
          filter: {
            ...getParamsGetCargoWiseJob.filter,
            ...(!!startJobStartDate ? { startJobStartDate } : {}),
            ...(!!startJobEndDate ? { startJobEndDate } : {}),
          }
        };
        getCargoWiseJob(payload);
      } else {
        if (isInterstateSwitch) { // For Interstate
          const getParamsGetInterstateJob = {
            ...paramsGetInterstateJob
          };
          delete getParamsGetInterstateJob?.filter?.startJobStartDate;
          delete getParamsGetInterstateJob?.filter?.startJobEndDate;
          const payload = {
            ...getParamsGetInterstateJob,
            page: 1,
            size: rowsPerPageVal,
            filter: {
              ...getParamsGetInterstateJob.filter,
              ...(!!startJobStartDate ? { startJobStartDate } : {}),
              ...(!!startJobEndDate ? { startJobEndDate } : {}),
            }
          };
          getInterstateJobs(payload);
        } else { // For Local
          const getParamsGetJob = {
            ...paramsGetJob
          };
          delete getParamsGetJob?.filter?.startJobStartDate;
          delete getParamsGetJob?.filter?.startJobEndDate;
          const payload = {
            ...getParamsGetJob,
            page: 1,
            size: rowsPerPageVal,
            filter: {
              ...getParamsGetJob.filter,
              ...(!!startJobStartDate ? { startJobStartDate } : {}),
              ...(!!startJobEndDate ? { startJobEndDate } : {}),
            }
          };
          getJobs(payload);
        }
      }
    }
  };

  const handlePeriodChange = (event, type) => {
    const { value } = event.target;
    setPeriod(value);
    setShow(false);
    if (!openFilter) {
      setFilter(
        "jobFilter",
        {
          ...filterData,
          period: value,
        },
        true
      );
    }
    if (value === 7 || type === true) {
      setOpen(true);
    } else {
      let startDate;
      let endDate;
      const newDate = new Date();
      if (value === "") {
        setFilterData({
          ...filterData,
          startDate: null,
          endDate: null,
        });
        setCustomDate({
          startDate: null,
          endDate: null,
        });
      } else if (value === 1) {
        startDate = moment(newDate).format("YYYY-MM-DD");
        endDate = moment(newDate).format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          startDate,
          endDate
        });
      } else if (value === 2) {
        startDate = moment(newDate).subtract(1, "day").format("YYYY-MM-DD");
        endDate = moment(newDate).subtract(1, "day").format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          startDate,
          endDate,
        });
      } else if (value === 3) {
        startDate = moment(newDate).subtract(3, "day").format("YYYY-MM-DD");
        endDate = moment(newDate).format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          startDate,
          endDate,
        });
      } else if (value === 4) {
        startDate = moment(newDate).subtract(7, "day").format("YYYY-MM-DD");
        endDate = moment(newDate).format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          startDate,
          endDate,
        });
      } else if (value === 5) {
        startDate = moment(newDate).subtract(14, "day").format("YYYY-MM-DD");
        endDate = moment(newDate).format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          startDate,
          endDate,
        });
      } else if (value === 6) {
        startDate = moment(newDate).subtract(30, "day").format("YYYY-MM-DD");
        endDate = moment(newDate).format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          startDate,
          endDate,
        });
      }
      resetPagination();

      if (isCargoWiseSwitch) {
        const getParamsGetCargoWiseJob = {
          ...paramsGetCargoWiseJob
        };
        delete getParamsGetCargoWiseJob?.filter?.startDate;
        delete getParamsGetCargoWiseJob?.filter?.endDate;
        const payload = {
          ...getParamsGetCargoWiseJob,
          page: 1,
          size: rowsPerPageVal,
          filter: {
            ...getParamsGetCargoWiseJob.filter,
            ...(!!startDate ? { startDate } : {}),
            ...(!!endDate ? { endDate } : {}),
          }
        };
        getCargoWiseJob(payload);
      } else {
        if (isInterstateSwitch) { // For Interstate
          const getParamsGetInterstateJob = {
            ...paramsGetInterstateJob
          };
          delete getParamsGetInterstateJob?.filter?.startDate;
          delete getParamsGetInterstateJob?.filter?.endDate;
          const payload = {
            ...getParamsGetInterstateJob,
            page: 1,
            size: rowsPerPageVal,
            filter: {
              ...getParamsGetInterstateJob.filter,
              ...(!!startDate ? { startDate } : {}),
              ...(!!endDate ? { endDate } : {}),
            }
          };
          getInterstateJobs(payload);
        } else { // For Local
          const getParamsGetJob = {
            ...paramsGetJob
          };
          delete getParamsGetJob?.filter?.startDate;
          delete getParamsGetJob?.filter?.endDate;
          const payload = {
            ...getParamsGetJob,
            page: 1,
            size: rowsPerPageVal,
            filter: {
              ...getParamsGetJob.filter,
              ...(!!startDate ? { startDate } : {}),
              ...(!!endDate ? { endDate } : {}),
            }
          };
          getJobs(payload);
        }
      }
    }
  };

  const handleClose = () => {
    setPeriod("");
    setOpen(false);
    setCustomDate({
      startDate: null,
      endDate: null,
    });
  };

  const handleStartJobClose = () => {
    setStartJobPeriod("");
    setOpenStartJob(false);
    setStartJobCustomDate({
      startJobStartDate: null,
      startJobEndDate: null,
    });
  };

  const handleCustomChange = (event, type) => {
    if (type === "startDate" || type === "endDate") {
      setCustomDate({
        ...customDate,
        [type]: moment(event).format("YYYY-MM-DD"),
      });
    } else {
      const { name, value } = event.target;
      setCustomDate({
        ...customDate,
        [name]: value,
      });
    }
  };
  const handleStartJobCustomChange = (event, type) => {
    if (type === "startJobStartDate" || type === "startJobEndDate") {
      setStartJobCustomDate({
        ...startJobCustomDate,
        [type]: moment(event).format("YYYY-MM-DD"),
      });
    } else {
      const { name, value } = event.target;
      setStartJobCustomDate({
        ...startJobCustomDate,
        [name]: value,
      });
    }
  };
  const resetPagination = () => {
    setPagination(prev => (
      {
        ...prev,
        page: 0,
        rowsPerPage: rowsPerPageVal
      }
    ));
  };

  useEffect(() => {
    handleReset(true);
  }, [isInterstateSwitch, isCargoWiseSwitch]);

  const handleSwitchChange = (event) => {
    setIsInterstateSwitch(event.target.checked);
    setAllowSearch(false);
    setIsCargoWiseSwitch(false);
    if (!event.target.checked) { // For Local
      delete paramsGetJob?.search;
      delete paramsGetJob?.order;
      delete paramsGetJob?.orderBy;
    } else { // For Interstate
      delete paramsGetInterstateJob?.search;
      delete paramsGetInterstateJob?.order;
      delete paramsGetInterstateJob?.orderBy;
    }
    setSearch('');
    setSort({
      order: "",
      orderBy: ""
    });
    setAllocate('');
    setSelectedArray([]);
    setMainCheck(false);
    setInterstateMode("interstate", event.target.checked);
    setDebounceSearch("");
  }

  const handleCargoWiseSwitchChange = () => {
    setIsCargoWiseSwitch(!isCargoWiseSwitch);
    setAllowSearch(false);
    setSelectedArray([]);
    setMainCheck(false);
    setIsInterstateSwitch(false);
    setInterstateMode("interstate", false);
    setSearch('');
    setDebounceSearch("");
  }

  const handleSwitchColdTrackingVehicle = (event) => {
    filterData.coldTrackingVehicle = event.target.checked;
    setFilterData({
      ...filterData,
      isColdTrackingVehicle: event.target.checked
    });
    resetPagination();

    const payload = {
      ...(isCargoWiseSwitch ? paramsGetCargoWiseJob : isInterstateSwitch ? paramsGetInterstateJob : paramsGetJob),
      page: 1,
      size: rowsPerPageVal,
      filter: {
        ...((isCargoWiseSwitch ? paramsGetCargoWiseJob : isInterstateSwitch ? paramsGetInterstateJob : paramsGetJob).filter),
        isColdTrackingVehicle: event.target.checked
      }
    };

    (isCargoWiseSwitch ? getCargoWiseJob : isInterstateSwitch ? getInterstateJobs : getJobs)(payload);
  }

  const handleSwitchDamageReportOnAwb = (event) => {
    filterData.damageReportOnAwb = event.target.checked;
    setFilterData({
      ...filterData,
      isDamageReportOnAwb: event.target.checked
    });
    resetPagination();

    const payload = {
      ...(isCargoWiseSwitch ? paramsGetCargoWiseJob : isInterstateSwitch ? paramsGetInterstateJob : paramsGetJob),
      page: 1,
      size: rowsPerPageVal,
      filter : {
        ...((isCargoWiseSwitch ? paramsGetCargoWiseJob : isInterstateSwitch ? paramsGetInterstateJob : paramsGetJob).filter),
        isDamageReportOnAwb: event.target.checked
      }
    };
    (isCargoWiseSwitch ? getCargoWiseJob : isInterstateSwitch ? getInterstateJobs : getJobs)(payload);
  }

  return (
    <>
      <Header />
      <div className={classes.JobListingWrapper}>
        <div className="dashboard-page wrapper">
          <div className="inner-page">
            <div className="title-panel">
              <Typography variant="h1">Jobs</Typography>
            </div>
            <div className={classes.innerPageTopBlock}>
              <div className="left-block">
                <FormGroup>
                  <Typography variant="h6">Interstate</Typography>
                  <FormControlLabel
                    control={<IOSSwitch checked={isInterstateSwitch} onChange={handleSwitchChange} />}
                  />
                </FormGroup>
                <span className="separate-func"></span>
                <FormGroup>
                  <Typography variant="h6">CargoWise</Typography>
                  <FormControlLabel
                    control={<IOSSwitch checked={isCargoWiseSwitch} onClick={handleCargoWiseSwitchChange} />}
                  />
                </FormGroup>
              </div>

              <div className="right-block">
                <div className="right-block-inner">
                  <div className="search-wrapper">
                    <div className="form-gourp">
                      <TextField
                        id="search-request"
                        placeholder={isCargoWiseSwitch ? "Search by job ID/Description" : "Search by ID/AWB/Cons./ULD/Info/Description"}
                        variant="outlined"
                        type="search"
                        InputProps={{
                          endAdornment: <img src={SearchIcon} alt="Search" />,
                        }}
                        value={search}
                        onChange={handleSearch}
                      />
                    </div>
                  </div>
                  {isCargoWiseSwitch ? (
                    <>
                      <div className="modal-wrapper">
                        {isPermission && (
                          <div className="btn-wrapper">
                            <Button
                              className="orange-btn primary-btn"
                              color="inherit"
                              disableElevation
                              onClick={handleClickShowData}
                              disabled={selectedArray.length === 0}
                            >
                              Review
                            </Button>
                          </div>
                        )}
                      </div>
                      <div className="dropdown_wrapper1">
                        <div className={classes.filter}>
                          <Filter
                            handleFilter={handleFilter}
                            filterData={filterData}
                            openFilterPopup={openFilterPopup}
                            closeFilerPopup={closeFilerPopup}
                            handleSubmit={handleSubmit}
                            handleClose={handleClose}
                            handlePeriodChange={handlePeriodChange}
                            handleCustomChange={handleCustomChange}
                            handleCustomDateSubmit={handleCustomDateSubmit}
                            period={period}
                            open={open}
                            show={show}
                            customDate={customDate}
                            startJobPeriod={startJobPeriod}
                            openStartJob={openStartJob}
                            showStartJob={showStartJob}
                            startJobCustomDate={startJobCustomDate}
                            handleStartJobPeriodChange={handleStartJobPeriodChange}
                            handleStartJobCustomChange={handleStartJobCustomChange}
                            handleStartJobCustomDateSubmit={
                              handleStartJobCustomDateSubmit
                            }
                            handleStartJobClose={handleStartJobClose}
                            handleReset={handleReset}
                            openFilter={openFilter}
                            isInterstate={isInterstateSwitch}
                            isCargoWise={isCargoWiseSwitch}
                            handleSwitchColdTrackingVehicle={handleSwitchColdTrackingVehicle}
                            handleSwitchDamageReportOnAwb={handleSwitchDamageReportOnAwb}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {!isInterstateSwitch && (
                        <div className="dropdown_wrapper">
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                          >
                            <Select
                              value={allocate}
                              onChange={handleAllocate}
                              displayEmpty
                              className={materilClasses.customSelect}
                              MenuProps={{
                                classes: { paper: materilClasses.customSelect },
                              }}
                              IconComponent={() => <ExpandMore />}
                            >
                              <MenuItem value={""}>Choose</MenuItem>
                              <MenuItem value={1}>Duration Over 3 Hours</MenuItem>
                              <MenuItem value={2}>
                                Jobs Waiting Time Over 2 Hours
                              </MenuItem>
                              <MenuItem value={3}>
                                Jobs Without Any Job Charge
                              </MenuItem>
                              <MenuItem value={4}>
                                Jobs With Review Not Completed
                              </MenuItem>
                              <MenuItem value={5}>
                                Jobs Whose AWB Is Not Taken Fully
                              </MenuItem>
                              <MenuItem value={6}>
                                Jobs With Child Account Not Being Mapped
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </div>)
                      }
                      <div className="modal-wrapper">
                        {/* https://wymap.atlassian.net/browse/MAPTRAK-1033  */}
                        {!isInterstateSwitch ? (
                          <CreateJob getJobs={getJobs} />
                        ) : (
                          <CreateInterstateJob getIntersateJobs={getInterstateJobs} isInterstate={isInterstateSwitch} />
                        )
                        }

                        {isPermission && (
                          <div className="btn-wrapper">
                            <Button
                              className="orange-btn primary-btn"
                              color="inherit"
                              disableElevation
                              onClick={handleClickShowData}
                              disabled={selectedArray.length === 0}
                            >
                              Review
                            </Button>
                          </div>
                        )}
                      </div>

                      {!isInterstateSwitch && (
                        <div className="modal-wrapper">
                          <CreateCompletedJob getJobs={getJobs} />
                        </div>)
                      }

                      <div className="dropdown_wrapper1">
                        <div className={classes.filter}>
                          <Filter
                            handleFilter={handleFilter}
                            filterData={filterData}
                            openFilterPopup={openFilterPopup}
                            closeFilerPopup={closeFilerPopup}
                            handleSubmit={handleSubmit}
                            handleClose={handleClose}
                            handlePeriodChange={handlePeriodChange}
                            handleCustomChange={handleCustomChange}
                            handleCustomDateSubmit={handleCustomDateSubmit}
                            period={period}
                            open={open}
                            show={show}
                            customDate={customDate}
                            startJobPeriod={startJobPeriod}
                            openStartJob={openStartJob}
                            showStartJob={showStartJob}
                            startJobCustomDate={startJobCustomDate}
                            handleStartJobPeriodChange={handleStartJobPeriodChange}
                            handleStartJobCustomChange={handleStartJobCustomChange}
                            handleStartJobCustomDateSubmit={
                              handleStartJobCustomDateSubmit
                            }
                            handleStartJobClose={handleStartJobClose}
                            handleReset={handleReset}
                            openFilter={openFilter}
                            isInterstate={isInterstateSwitch}
                            isCargoWise={isCargoWiseSwitch}
                            handleSwitchColdTrackingVehicle={handleSwitchColdTrackingVehicle}
                            handleSwitchDamageReportOnAwb={handleSwitchDamageReportOnAwb}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            {isCargoWiseSwitch ? (
              <CargoWiseJobTableListing
                handleChange={handleChange}
                handleMainChange={handleMainChangeCheckBox}
                _maincheck={mainCheck}
                page={pagination.page}
                handleChangePage={handleChangePage}
                rowsPerPage={pagination.rowsPerPage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                handleSorting={(e, property) => handleSorting(e, property)}
                orderBy={sort.orderBy}
                order={sort.order}
                getCargoWiseJob={getCargoWiseJob}
                isCargoWise={isCargoWiseSwitch}
                dataTable={dataTable}
              />
            ) : (
              <TableListing
                handleChange={handleChange}
                handleMainChange={handleMainChangeCheckBox}
                _maincheck={mainCheck}
                page={pagination.page}
                handleChangePage={handleChangePage}
                rowsPerPage={pagination.rowsPerPage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                handleSorting={(e, property) => handleSorting(e, property)}
                orderBy={sort.orderBy}
                order={sort.order}
                getJobs={getJobs}
                getInterstateJobs={getInterstateJobs}
                isInterstate={isInterstateSwitch}
                dataTable={dataTable}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default JobListing;
